/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Opt this installation's Salesforce subscription into record-triggered flows and outbound messages instead of Change Data Capture. Delete events are not supported on this path. Defaults to false (CDC).
 * @export
 * @interface UseSalesforceFlowsConfig
 */
export interface UseSalesforceFlowsConfig {
    /**
     * Whether this installation uses Salesforce record-triggered flows for subscribe.
     * @type {boolean}
     * @memberof UseSalesforceFlowsConfig
     */
    enabled: boolean;
    /**
     * Whether the customer creates and maintains the flows and outbound messages in their Salesforce org themselves. When true, Ampersand never creates, updates or deletes them; the customer's outbound messages post to the installation's subscribe webhook URL. Requires `enabled` to be true. Defaults to false.
     * @type {boolean}
     * @memberof UseSalesforceFlowsConfig
     */
    manualManagement?: boolean;
}

/**
 * Check if a given object implements the UseSalesforceFlowsConfig interface.
 */
export function instanceOfUseSalesforceFlowsConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function UseSalesforceFlowsConfigFromJSON(json: any): UseSalesforceFlowsConfig {
    return UseSalesforceFlowsConfigFromJSONTyped(json, false);
}

export function UseSalesforceFlowsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseSalesforceFlowsConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'manualManagement': !exists(json, 'manualManagement') ? undefined : json['manualManagement'],
    };
}

export function UseSalesforceFlowsConfigToJSON(value?: UseSalesforceFlowsConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'manualManagement': value.manualManagement,
    };
}

